export default {
  name: 'facet-nav-refinement-color-facet',
  mixins: [],
  props: [
    'inverted',
    'values'
  ],

  data () {
    return {
    }
  },

  methods: {
  },

  computed: {
    hasImageUrl () {
      return !!this.imageurl.replace(/\s/g, '').length
    },
    hasHexaColor () {
      return !!this.hexacolor.replace(/\s/g, '').length
    },
    
    name() {
      return this.values.split('|')[0]
    },
    hexacolor() {
      return this.values.split('|')[1]
    },
    imageurl() {
      return this.values.split('|')[2]
    }
  },

  mounted: function () {
  },

  watch: {
  }
}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/facetnavrefinementcolorfacet/facetnavrefinementcolorfacet.js